/* global $ */

class MouseStalker {
  constructor() {
    this.$front = $('#MouseStalker');

    this.mouseX = this.frontPosX = this.backPosX = 0;
    this.mouseY = this.frontPosY = this.backPosY = 0;

    this.mouseOutTimer = undefined;
    this.isHover = false;
    this.isStart = false;
    this.startCount = 0;

    let touch_event = window.ontouchstart;
    let touch_points = navigator.maxTouchPoints;

    if (!(touch_event !== undefined && 0 < touch_points)) {
      $(document).on('mouseover', 'a.Card , .BoxButton', () => {
        clearInterval(this.mouseOutTimer);
        if (!this.isHover) {
          this.isHover = true;
          this.$front.addClass('is-active');
        }
      });

      $(document).on('mouseout', 'a.Card , .BoxButton', () => {
        clearInterval(this.mouseOutTimer);
        this.mouseOutTimer = setInterval(() => {
          if (this.isHover) {
            this.$front.removeClass('is-active');
            this.isHover = false;
          }
          clearInterval(this.mouseOutTimer);
        }, 50);
      });

      document.addEventListener('mousemove', (e) => {
        if (this.isStart) {
          this.mouseX = e.clientX;
          this.mouseY = e.clientY;
        } else {
          this.startCount++;
          if (this.startCount == 10) {
            this.mouseX = this.frontPosX = this.backPosX = e.clientX;
            this.mouseY = this.frontPosY = this.backPosY = e.clientY;
            this.$front.css(
              'transform',
              `translate(${this.frontPosX}px, ${this.frontPosY}px) scale(1)`
            );
            this.isStart = true;
          }
        }
      });
      this.update();
    }
  }
  update() {
    if (this.isStart) {
      this.frontPosX += (this.mouseX - this.frontPosX) / 3;
      this.frontPosY += (this.mouseY - this.frontPosY) / 3;

      this.backPosX += (this.mouseX - this.backPosX) / 6;
      this.backPosY += (this.mouseY - this.backPosY) / 6;

      this.$front.css(
        'transform',
        `translate(${this.frontPosX}px, ${this.frontPosY}px)`
      );
    }

    requestAnimationFrame(() => {
      this.update();
    });
  }
}

export default MouseStalker;
